module.exports = __webpack_public_path__ + "img/service-headshot.e9e94ed2.jpg";